<template>
  <div v-if="isLoggedIn" class="profile-page d-flex flex-md-row flex-column px-4 py-4 mb-4">
    <ProfileSidebar />
    <main class="content ps-md-4">
      <router-view />
    </main>
    <MobileBar />
  </div>
</template>

<script>
  import { defineComponent, computed, onMounted } from 'vue';
  import ProfileSidebar from '@/components/Profile/Sidebar.vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import MobileBar from '@/components/Profile/MobileBar.vue';

  export default defineComponent({
    name: 'Profile',
    components: { ProfileSidebar, MobileBar },
    setup() {
      const store = useStore();
      const isLoggedIn = computed(() => store.state.auth.status.loggedIn);
      const router = useRouter();

      onMounted(() => {
        if (!isLoggedIn.value) {
          router.push('/');
        } else {
          store.dispatch('user/getCartItems');
        }
      });

      return {
        isLoggedIn,
      };
    },
  });
</script>

<style lang="scss">
  @import '../assets/styles/Profile';
</style>
